export default {
  search:{
    placeholder: "Поиск",
    enterButton: "Найти",
  },
  repository:{
    load_next_tooltip  : `Загружено {{present}} из {{count}}`,
    load_next: "Загрузить ещё",
  },
  adms:{
    repository_tooltip  : `Всего {{count}} записей. Ещё доступно {{length}} записей.`,
    repository_load_next: "Загрузить ещё",
    distribution: {
      title: "Распространение элемента каталога",
      nolinks: "Распространение элемента каталога не осуществляется.",
      nofiles: "Для содержимого нет файла для скачивания",
      show: {
        title: "Детальная информация о распространении",
        cancelText: "Отмена",
        okText: "Ок",
        },
      add: {
        title: "Выбор файла для связывания",
        cancelText: "Отменить",
        okText: "Связать",
        },
      new: {
        title: "Новое распространение",
        cancelText: "Отменить",
        okText: "Создать",
        },
      unlink:{
        title: 'Удалить выбранный элемент',
        okText: 'Да', 
        cancelText: 'Нет',
      },
      message: {
        ok_link: "Файл добавлен.",
        ok_new:  "Создана запись распространения",
        ok_unlink: "Запись удалена.",
        e_detail: "Ошибка при получении дополнительной информации и распространении элемента каталога. {{detail}}",
        e_wiki: "Ошибка при получении дополнительной информации о статьях. {{detail}}",
        e_search: "Ошибка при поиске файлов. {{detail}}",
        e_new: "Ошибка создания записи распространения.  {{detail}}",
        not_downloadURL: "Для заполнения необходимо в поле Скачать указать ссылку на файл.",
      }
    },
  },
  alphabet: {
    letters: "АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧЧШЩЭЮЯ",
    loading: "Загрузка алфавита"
  },
  editor:{
    theme: {
      new : {
        title: "Новый классификатор",
        cancelText: "Отменить",
        okText: "Создать"
      },
      select : {
        title: "Выбрать классификатор",
        cancelText: "Отменить",
        okText: "Связать"
      },
      message: {
        ok_link: "Связь установлена.",
        ok_new:  "Классификатор добавлен и связь с каталогом установлена",
        e_new: "Ошибка создания классификатора или установка связи.  {{detail}}",
        e_unlink: "Ошибка удаления связи.  {{detail}}",
      }
    },
    individual: {
      new : {
        title: "Новый элемент'",
        cancelText: "Отменить",
        okText: "Создать"
      },
      select : {
        title: "Выбрать элемент",
        cancelText: "Отменить",
        okText: "Связать"
      },
      message: {
        ok_link: "Связь установлена.",
        ok_new:  "Элемент добавлен и связь с установлена",
        e_new: "Ошибка создания элемента или установка связи.  {{detail}}",
        e_unlink: "Ошибка удаления связи.  {{detail}}",
      }
    },
    literal: {
      message: {
        ok_save: "Данные успешно сохранены",
      }
    },
  },
  export: {
    doc_book: "В Doc (книжный)",
    doc_album: "В Doc (альбомный)",
    pdf_book: "В Pdf (книжный)",
    pdf_album: "В Pdf (альбомный)",
  },
  skos: {
    taxonomy_not_loaded: "Таксономия каталога не задана или не загружена!",
    conceptSmall: {
      details: "Детальная информация",
      deleteConcept: "Удалить концепт",
      unlinkFromScheme: "Исключить из справочника",
      unlinkConcept: "Исключить концепт",
      replaceWithConcept: "Заменить на концепт",
      editConcept: "Редактировать концепт"
    },
    deleteScheme: {
      title: "Удаление справочника",
      cancel: "Отмена",
      close: "Закрыть",
      delete: "Удалить",
      loadingScheme: "Загрузка описания справочника…",
      loadingConcepts: "Загрузка списка концептов…",
      deletingConcept: "Удаление концепта {{current}} из {{total}}…",
      deletingScheme: "Удаление справочника…",
      deleted: "Справочник и все его концепты удалены.",
      irreversible: "Удаление необратимо",
      warning: "Перед удалением рекомендуется экспортировать справочник или обратиться к администратору для его архивирования. Будут последовательно удалены все концепты справочника, а затем сам справочник.",
      deleteError: "Ошибка удаления"
    },
    selectConcept: {
      loaderMissing: "Не передана функция загрузки",
      loadConceptsError: "Ошибка получения списка концептов",
      loadLabelsError: "Ошибка загрузки меток",
      searchPlaceholder: "Поиск по URI или по содержимому метки",
      reload: "Обновить",
      found: "Найдено: {{filtered}} из {{total}}",
      allConcepts: "Все концепты",
      unlinkedConcepts: "Несвязанные концепты",
      error: "Ошибка",
      loadingUris: "Загрузка URI...",
      loadingLabels: "Загрузка меток...",
      notFound: "Концепты не найдены",
      select: "Выбрать",
      noLabel: "Без метки",
      labelsNotFound: "Метки не найдены",
      firstItemsShown: "Показаны первые {{count}} элементов. Уточните строку поиска, чтобы сузить список."
    },
    taxonomyValues: {
      deleteClassification: "Удаление классификации",
      editClassification: "Редактирование классификации",
      schemeMissing: "Схема для {{info}} отсутствует",
      deleteConfirmation: "Удалить выбранную классификацию?",
      yes: "Да",
      no: "Нет",
      reloadToViewChanges: "Для просмотра изменений перегрузите страницу."
    }
  },
  widgets: {
    description_moreText: "Далее",
    description_lessText: "Свернуть",
  },
  wiki: {
    title: "Wiki статьи",
    nolinks: "Нет связанных wiki статей",
    select: {
      title: "Выбор wiki-статьи",
      cancelText: "Отменить",
      okText: "Связать",
    },
    show: {
      title: "Детальная информация о Wiki-статье",
      cancelText: "Отмена",
      okText: "Ок",
    },
    new: {
      title: "Новая статья",
      cancelText: "Отменить",
      okText: "Создать",
    },
    unlink_dialog:{
      title: 'Удалить выбранный элемент',
      okText: 'Да', 
      cancelText: 'Нет',
    },
    message: {
      ok_link: "Статья добавлена.",
      ok_unlink: "Запись удалена.",
      e_detail: "Ошибка при получении дополнительной информации и распространении элемента каталога. {{detail}}",
      e_wiki: "Ошибка при получении дополнительной информации о статьях. {{detail}}",
      e_search: "Ошибка при поиске статей. {{detail}}",
      not_URL: "Для заполнения необходимо в поле Wiki статья ссылку на HTML старницу.",
    }
  },
  settings:{
    settings_taxonomy: "Настройка классификаторов",
    taxonomy: "Классификаторы",
    settings_object: "Настройка справочников объектных свойств",
    object: "Справочники",
    catalog_public: "Открытый каталог",
    catalog_signed: "Закрытый каталог",
    include_catalog: "Включить в каталог",
    exclude_catalog: "Исключить из каталога"
  }
}
